import { Input } from "@drs-ops/ui";
import { useState } from "react";
import type { HotelTierMapRow } from "@/types/hotelTierMap";

export interface TierEquivalencyRowProps {
  row: HotelTierMapRow;
  onSave: (brand: string, comparable: string[]) => void;
}

export function TierEquivalencyRow({ row, onSave }: TierEquivalencyRowProps): React.ReactElement {
  const [draft, setDraft] = useState(row.comparable_brands.join(", "));
  return (
    <tr className="border-t border-border">
      <td className="p-2 font-medium">{row.hilton_brand}</td>
      <td className="p-2 text-muted-foreground">{row.tier}</td>
      <td className="p-2">
        <Input
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onBlur={() => {
            const next = draft
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean);
            const current = row.comparable_brands;
            if (next.length !== current.length || next.some((v, i) => v !== current[i])) {
              onSave(row.hilton_brand, next);
            }
          }}
        />
      </td>
    </tr>
  );
}
